// Copyright (c) 2025 DTCC and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { UseMutationResult, useMutation } from '@tanstack/react-query';
import { ComplianceService } from '@daml.js/dtc-registry-app/lib/Dtc/Registry/App/V3/Service/Compliance';
import { ContractId } from '@daml/types';
import { useLedgerApiClient } from '../../../../contexts/LedgerApiContext';
import { useParties } from '../../../../contexts/PartiesContext';

const useTerminateComplianceService: () => UseMutationResult<
  void,
  string,
  { complianceServiceCid: ContractId<ComplianceService> }
> = () => {
  const ledgerApi = useLedgerApiClient();
  const { party } = useParties();

  return useMutation({
    mutationKey: ['terminateRegistryComplianceService', ledgerApi],
    mutationFn: async ({ complianceServiceCid }) =>
      ledgerApi.terminateRegistryComplianceService(complianceServiceCid, party),
    retry: false,
  });
};

export default useTerminateComplianceService;
